// src/index.ts
import { useId, useCallback } from "react";
import { useValueEffect, useLayoutEffect } from "@react-aria/utils";
function useAriaSlotId(depArray = []) {
  let id = useId();
  let [resolvedId, setResolvedId] = useValueEffect(id);
  let updateId = useCallback(() => {
    setResolvedId(function* () {
      yield id;
      yield document.getElementById(id) ? id : void 0;
    });
  }, [id, setResolvedId]);
  useLayoutEffect(updateId, [id, updateId, ...depArray]);
  return resolvedId;
}
export {
  useAriaSlotId
};
